import _classCallCheck from "/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/** Add node transaction to the event */
var Transaction =
/*#__PURE__*/
function () {
  _createClass(Transaction, null, [{
    key: "__initStatic",

    /**
     * @inheritDoc
     */
    value: function __initStatic() {
      this.id = 'Transaction';
    }
    /**
     * @inheritDoc
     */

  }]);

  function Transaction() {
    _classCallCheck(this, Transaction);

    this.name = Transaction.id;
  }
  /**
   * @inheritDoc
   */


  _createClass(Transaction, [{
    key: "setupOnce",
    value: function setupOnce(addGlobalEventProcessor, getCurrentHub) {
      addGlobalEventProcessor(function (event) {
        var self = getCurrentHub().getIntegration(Transaction);

        if (self) {
          return self.process(event);
        }

        return event;
      });
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "process",
    value: function process(event) {
      var frames = this._getFramesFromEvent(event); // use for loop so we don't have to reverse whole frames array


      for (var i = frames.length - 1; i >= 0; i--) {
        var frame = frames[i];

        if (frame.in_app === true) {
          event.transaction = this._getTransaction(frame);
          break;
        }
      }

      return event;
    }
    /** JSDoc */

  }, {
    key: "_getFramesFromEvent",
    value: function _getFramesFromEvent(event) {
      var exception = event.exception && event.exception.values && event.exception.values[0];
      return exception && exception.stacktrace && exception.stacktrace.frames || [];
    }
    /** JSDoc */

  }, {
    key: "_getTransaction",
    value: function _getTransaction(frame) {
      return frame.module || frame.function ? "".concat(frame.module || '?', "/").concat(frame.function || '?') : '<unknown>';
    }
  }]);

  return Transaction;
}();

Transaction.__initStatic();

export { Transaction };